const assetsHost = process.env.VUE_APP_CMS_URI;
let state = {
  chats: [],
  authors: {},
  currentChatgroupId: false,
  history: false,
  hasHistory: false,
  historyChapterIndex: 0,
  data: {},
  userName: null,
};

/**
 * 
 */
function transformChats(data) {
  state.data = data;
  const { chaptersToShow, history } = data;

  setHistoryData(history);
  setDataToShow(chaptersToShow);

  return state.chats;
}

/**
 * 
 */
function getAuthors(data) {
  if (Object.keys(state.authors).length == 0) setChatsAuthors(data);
  return state.authors;
}

/**
 * 
 */
function setUserName(name) {
  state.userName = name;
}

/**
 * 
 */
function setHistoryData(historyData) {
  state.history = true;
  historyData.forEach((chapter, chapterIndex) => {
    state.historyChapterIndex = chapterIndex;
    const { chatgroups } = chapter;
    processHistoryChatgroups(chatgroups);
  });

  if (historyData && historyData.length > 0) {
    state.hasHistory = true;
  }
}

/**
 * 
 */
function processHistoryChatgroups(chatgroups) {
  chatgroups.forEach(chatgroup => {
    const { team, id } = chatgroup;
    const teamId = team.id;
    let chat = prepareChatFromChatgroup(chatgroup);
    chat = getChatgroupAsActive(chat, true);

    if (!hasChatgroupInChatsByTeamId(teamId)) {
      setCurrentChatgroupId(id);
      insertNewChatToChats(chat);
    } else {
      insertHistoryMessagesToExistingChat(chatgroup, teamId);
    }
  });
}

/**
 * 
 */
function setDataToShow(chapters) {
  state.history = false;
  chapters.forEach((chapter, chapterIndex) => {
    const { chatgroups } = chapter;

    processDataToShowChatgroups(chatgroups, chapterIndex, chapters);
  });
}

/**
 * 
 */
function processDataToShowChatgroups(chatgroups, chapterIndex, chapters) {
  const chatgroupsSize = chatgroups.length;
  chatgroups.forEach((chatgroup, chatgroupIndex) => {
    const { team, id } = chatgroup;
    const teamId = team.id;
    const nextChatgroup = getNextChatgroup(chatgroups, chatgroupIndex, chapterIndex);
    let chat = prepareChatFromChatgroup(chatgroup, chatgroupIndex, chatgroupsSize, nextChatgroup, chapters, chapterIndex);

    if (chapterIndex === 0 && chatgroupIndex === 0) {
      chat = getChatgroupAsActive(chat, true);
    }

    if (!hasChatgroupInChatsByTeamId(teamId)) {
      setCurrentChatgroupId(id);
      insertNewChatToChats(chat);
    } else {
      insertDataToExistingChat(chatgroup, chatgroups, chatgroupIndex, chatgroupsSize, chapters, chapterIndex);
    }
  });
}

/**
 * 
 */
function setCurrentChatgroupId(chatgroupId) {
  state.currentChatgroupId = chatgroupId.toString();
}

/**
 * 
 */
function getNextChatgroup(chatgroups, chatgroupIndex, chapterIndex) {
  const { data } = state;
  const nextChatgroup = chatgroups[chatgroupIndex + 1];
  const nextChapter = data.chaptersToShow[chapterIndex + 1];
  const nextChapterChatgroup = nextChapter && nextChapter.chatgroups[0];

  return nextChatgroup || nextChapterChatgroup;
}

/**
 * 
 */
function prepareChatFromChatgroup(chatgroup, chatgroupIndex, chatgroupsSize, nextChatgroup, chapters, chapterIndex) {
  const { team, id } = chatgroup;
  const { characters, name } = team;
  const { messages, script } = getChatMessagesAndScript(chatgroup);
  const teamId = team.id;

  if (chatgroupsSize === chatgroupIndex + 1) {
    const nextChapter = chapters[chapterIndex + 1];
    if (nextChapter) script.push(getChapterEndToScript(chapterIndex, nextChapter, teamId));
  }

  return {
    id: teamId.toString(),
    chatgroupId: id.toString(),
    name: name,
    active: false,
    answer: "",
    profilePhoto: getChatProfilePhotoFromCharacters(characters),
    profileCover: "https://images.unsplash.com/photo-1581826333631-38a49802b287?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
    messageLoading: false,
    notificationShow: false,
    notification: getNotification(nextChatgroup), // TODO if script length 0 then add new data!!!
    messages,
    script,
  }
}

/**
 * 
 */
function getChatProfilePhotoFromCharacters(characters) {
  return characters.map(character => `${assetsHost}${character.image.path}`);
}

/**
 * 
 */
function getNotification(nextChatgroup) {
  const { team, content } = nextChatgroup || {};
  const { id, name } = team || {};

  if (nextChatgroup) {
    const notificationIndex = getNotificationIndex(content);
    return {
      nextChatId: id.toString(),
      textHeader: getNotificationTextHeader(name),
      textDesc: getNotificationTextDesc(content[notificationIndex])
    }
  }

  return {
    nextChatId: "",
    textHeader: "",
    textDesc: ""
  };
}

/**
 * 
 */
function getNotificationIndex(messages) {
  let notificationIndex = 0;
  messages.forEach((message, messageIndex) => {
    const { contentType } = message;
    if (isSeparatorType(contentType)) notificationIndex = messageIndex - 1;
  })
  return notificationIndex;
}

/**
 * 
 */
function getNotificationTextHeader(name) {
  return state.data.contentLanguage.slice(0, 2) === "en" ? 'New message from ' + name : 'Ny melding fra ' + name
}

/**
 * 
 */
function getNotificationTextDesc(chatgroupMessage) {
  const { message, sender, contentType } = chatgroupMessage;
  const { name } = sender;

  if (contentType === "ConversationContentModel") return getNotificationTextDescMessage(message);
  if (contentType === "ImageContentModel") return state.data.contentLanguage.slice(0, 2) === "en" ? `${name} has sent a picture` : `${name} har sendt en bilde`;
  if (contentType === "GifContentModel") return state.data.contentLanguage.slice(0, 2) === "en" ? `${name} has sent a boomerang` : `${name} har sendt en boomerang`;
  if (contentType === "VideoContentModel") return state.data.contentLanguage.slice(0, 2) === "en" ? `${name} has sent a video` : `${name} har sendt en film`;

  return "";
}

/**
 * 
 */
function getNotificationTextDescMessage(message) {
  if (message.length > 30) return message.slice(0, 35) + "...";
  return message;
}

/**
 * 
 */
function getChatMessagesAndScript(chatgroup) {
  const { content } = chatgroup;
  let messages = [];
  let script = [];

  content.forEach((message, messageIndex) => {
    const { contentType } = message;

    if (isMessageAddableContentType(contentType) || isBranchType(contentType)) {
      if ((messageIndex === 0 && !isBranchType(contentType)) || (!state.hasHistory && state.history)) {
        messages.push(prepareChatMessage(message, content));
      } else {
        script.push(prepareChatMessage(message, content))
      }
    }

    if (isSeparatorType(contentType)) {
      messages = [...messages, ...script];
      script = [];
    }
  });

  return {
    messages: messages.filter(message => message && message),
    script: script.filter(script => script && script)
  }
}

/**
 * 
 */
function prepareChatMessage(message, chatgroupMessages) {
  const { order } = message;

  if (hasOrder(order) && !state.history) {
    return prepareBranchMessage(message, chatgroupMessages);
  } else {
    return prepareMessageByContentType(message);
  }
}

/**
 * 
 */
function prepareBranchMessage(message, chatgroupMessages) {
  const { contentType, sender, delay, key, saveAnswer, childIds } = message;

  if (contentType === "BranchContentModel") {
    return {
      type: "answer",
      content_type: getBranchContentType(message, chatgroupMessages),
      author: getMessageAuthor(sender),
      value: prepareBranchValues(message, chatgroupMessages),
      additionalScript: prepareBranchAdditionalScript(message, chatgroupMessages),
      parentId: key,
      delay,
      saveAnswer,
      childIds,
    }
  }
}

/**
 * 
 */
function getBranchContentType(message, chatgroupMessages) {
  const { childIds } = message;
  const firstChildMessage = chatgroupMessages.find(chatgroupMessage => chatgroupMessage.key === childIds[0]);
  const { contentType } = firstChildMessage;
  return getMessageContentType(contentType);
}

/**
 * 
 */
function prepareBranchValues(message, chatgroupMessages) {
  const { childIds } = message;
  const firstChildMessage = chatgroupMessages.find(chatgroupMessage => chatgroupMessage.key === childIds[0]);
  const secondChildMessage = chatgroupMessages.find(chatgroupMessage => chatgroupMessage.key === childIds[1]);

  return [
    getMessageValue(firstChildMessage),
    getMessageValue(secondChildMessage),
  ]
}

/**
 * 
 */
function prepareBranchAdditionalScript(message, chatgroupMessages) {
  const { childIds } = message;
  const firstChildMessage = chatgroupMessages.find(chatgroupMessage => chatgroupMessage.key === childIds[0]);
  const secondChildMessage = chatgroupMessages.find(chatgroupMessage => chatgroupMessage.key === childIds[1]);
  const firstChildMessageChildIds = firstChildMessage.childIds;
  const secondChildMessageChildIds = secondChildMessage.childIds;
  let additionalScript = {};

  if (firstChildMessageChildIds.length > 0 || secondChildMessageChildIds.length > 0) {
    additionalScript = {
      A: getAdditionalScriptMessages(firstChildMessageChildIds, chatgroupMessages),
      B: getAdditionalScriptMessages(secondChildMessageChildIds, chatgroupMessages)
    };
  }

  return additionalScript;
}

/**
 * 
 */
function getAdditionalScriptMessages(childIds, chatgroupMessages) {
  let messages = [];
  childIds.forEach(childId => {
    const messageByChildId = chatgroupMessages.find(message => message.key === childId);
    messages.push(prepareMessageByContentType(messageByChildId));
  });
  return messages;
}

/**
 * 
 */
function prepareMessageByContentType(message) {
  const { contentType, sender, delay, key } = message;

  if (isMessageAddableContentType(contentType)) {
    return {
      type: "message",
      content_type: getMessageContentType(contentType),
      author: getMessageAuthor(sender),
      value: getMessageValue(message),
      additionalScript: {},
      delay,
      key,
    }
  }
}

/**
 * 
 */
function getMessageContentType(contentType) {
  if (isTextType(contentType)) return "text";
  if (isImageType(contentType)) return "image";
  if (isVideoType(contentType)) return "video";
  return "";
}

/**
 * 
 */
function getChatgroupAsActive(chat, active) {
  return {
    ...chat,
    active,
  }
}

/**
 * 
 */
function getMessageAuthor(sender) {
  if (sender) {
    if (sender.name === "me") return "";
    return sender.name;
  }
}

/**
 * 
 */
function getMessageValue(chatgroupMessage) {
  const { message, contentType, url, thumbnailUrl, subtitlesFileUrl } = chatgroupMessage;

  if (isImageType(contentType)) {
    return `${assetsHost}${url}`;
  }

  if (isVideoType(contentType)) {
    return {
      url: `${assetsHost}${url}`,
      cover: thumbnailUrl && `${assetsHost}${thumbnailUrl}` || require("@/assets/media/019-party-preparations.jpg"),
      subtitles: subtitlesFileUrl && `${assetsHost}${subtitlesFileUrl}`,
    };
  }

  if (isTextType(contentType) && state.userName) {
    return message.replace(/\[Me\]/g, state.userName)
  }

  return message || "";
}

/**
 * 
 */
function insertNewChatToChats(chat) {
  state.chats = [...state.chats, chat];
}

/**
 * 
 */
function insertHistoryMessagesToExistingChat(chatgroup, teamId) {
  const { messages } = getChatMessagesAndScript(chatgroup);

  state.chats = state.chats.map(chat => {
    if (chat.id === teamId.toString()) {
      return {
        ...chat,
        messages: [...chat.messages, ...messages]
      };
    }
    return chat;
  });
}

/**
 * 
 */
function insertDataToExistingChat(chatgroup, chatgroups, chatgroupIndex, chatgroupsSize, chapters, chapterIndex) {
  const { team } = chatgroup;
  const { id } = team;
  const { messages, script } = getChatMessagesAndScript(chatgroup);
  const nextChatgroup = getNextChatgroup(chatgroups, chatgroupIndex, chapterIndex);
  const { currentChatgroupId } = state;

  if (chatgroupsSize === chatgroupIndex + 1) {
    const nextChapter = chapters[chapterIndex + 1];
    if (nextChapter) script.push(getChapterEndToScript(chapterIndex, nextChapter, id));
  }

  state.chats = state.chats.map(chat => {

    if (chat.chatgroupId === currentChatgroupId) {
      const dataToInsert = {
        messages: messages,
        script: script,
        notification: getNotification(nextChatgroup),
      };

      if (state.hasHistory && chatgroupIndex === 0 && chapterIndex === 0) {
        chat.messages = [...chat.messages, ...dataToInsert.messages];
        chat.script = dataToInsert.script;
        chat.notification = dataToInsert.notification;
        if (script.length === 0) {
          chat.notificationShow = true;
        }

      } else {
        if (!chat.newData) {
          chat.newData = dataToInsert;
        } else {
          chat.newData.import = recursiveImports(chat.newData, dataToInsert);
        }
      }
    }

    return chat;
  });
}

/**
 * 
 */
function recursiveImports(newData, dataToInsert) {
  if (!newData.import) {
    return dataToInsert;
  } else {
    return {
      ...newData.import,
      import: recursiveImports(newData.import, dataToInsert),
    };
  }
}

/**
 * 
 */
function getChapterEndToScript(chapterIndex, nextChapter, teamId) {
  const { name, chatgroups } = nextChapter || {};
  const nextChapterFirstChatgroup = chatgroups && chatgroups[0] || {};
  const { team } = nextChapterFirstChatgroup || {};
  const { id } = team || {};

  return {
    type: teamId === id ? "chapter-end-same-chat" : "chapter-end",
    content_type: "text",
    value: `<p>${state.data.contentLanguage.slice(0, 2) === "en" ? 'Chapter' : 'Kapittel'} ${state.historyChapterIndex + chapterIndex + 1}</p> <span>${name}</span>`,
  }
}

/**
 * 
 */
function setChatsAuthors(data) {
  const chapters = [...data.chaptersToShow, ...data.history];
  const authors = {};

  chapters.forEach(chapter => {
    chapter.chatgroups.forEach(chatGroup => {
      chatGroup.team.characters.forEach(character => {
        authors[character.name] = character;
      });
    });
  });

  for (let author of Object.values(authors)) {
    if (author.image && author.image.path) {
      author.image.path = `${assetsHost}${author.image.path}`;
    }
  }

  state.authors = authors;
}

/**
 * 
 */
function hasChatgroupInChatsByTeamId(teamId) {
  const { chats } = state;
  return chats.find((chat) => chat.id === teamId.toString());
}

/**
 * 
 */
function isMessageAddableContentType(contentType) {
  return isTextType(contentType) ||
    isImageType(contentType) ||
    isVideoType(contentType);
}

/**
 * 
 */
function isTextType(contentType) {
  return contentType === "ConversationContentModel";
}

/**
 * 
 */
function isImageType(contentType) {
  return contentType === "ImageContentModel" || contentType === "GifContentModel";
}

/**
 * 
 */
function isVideoType(contentType) {
  return contentType === "VideoContentModel";
}

/**
 * 
 */
function isBranchType(contentType) {
  return contentType === "BranchContentModel";
}

/**
 * 
 */
function isSeparatorType(contentType) {
  return contentType === "StartPointContentModel";
}

/**
 * 
 */
function hasOrder(order) {
  return order && order.length > 0;
}

export {
  transformChats, getAuthors, setUserName,
}